var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _polygon, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 65,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 85 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t.cls-1{fill:transparent;}\r\n\t\t\t.cls-2{fill:#656565;}\r\n\t\t"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 85,
    height: 65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.64,38.55h1.58l2.16,5.79,0-5.79h1.45v8.27H22.21L20,41l0,5.8H18.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.78,39.4a2.25,2.25,0,0,1,2.18-1,2.25,2.25,0,0,1,2.18,1,6.76,6.76,0,0,1,.51,3.29A6.79,6.79,0,0,1,30.14,46,2.25,2.25,0,0,1,28,47a2.25,2.25,0,0,1-2.18-1,6.73,6.73,0,0,1-.51-3.29A6.73,6.73,0,0,1,25.78,39.4ZM28,45.79c1.06,0,1.1-.95,1.1-3.1s0-3.11-1.11-3.11-1.11,1-1.11,3.11S26.9,45.79,28,45.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.46,38.55H39v8.27H37.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.63,38.55H43l1.13,5.36,1.13-5.36h2.32v8.27H46.06l0-7.34-1.54,7.34h-.95l-1.54-7.34,0,7.34H40.63Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.61,38.55h2.07l1.88,8.27H52.9l-.41-2.08H50.72l-.4,2.08H48.75Zm1.66,5L51.62,40,51,43.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.57,45.91A1.64,1.64,0,0,1,57.79,47c-1.9,0-2.35-1.43-2.35-4.59a6,6,0,0,1,.52-3.1,2.36,2.36,0,0,1,2.18-1c1.77,0,2.6.81,2.6,2.58v.21H59.28v-.09c0-1-.37-1.5-1.1-1.5-1.15,0-1.17,1-1.17,3.25,0,2.06.17,2.94,1.09,2.94s1.13-.56,1.13-1.84v-.29H58.17V42.32h2.55v4.51h-1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.33,38.55h4.25v1.38H63.86v1.92h2.53v1.31H63.86v2.28h2.78v1.4H62.33Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.89,49.55H22l1.88,8.27H22.18l-.41-2.08H20l-.4,2.08H18Zm1.66,5L20.89,51l-.65,3.47Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.74,49.55h1.65l1.23,6.6,1.11-6.6h1.63l-1.74,8.27h-2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.21,49.55h2.07l1.88,8.27H33.5l-.41-2.08H31.32l-.4,2.08H29.35Zm1.66,5L32.21,51l-.65,3.47Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.13,49.55h1.54v8.27H36.13Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.06,49.55H40.6v6.87h2.78v1.41H39.06Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46,49.55h2.07L50,57.83H48.31l-.41-2.08H46.13l-.4,2.08H44.16Zm1.66,5L47,51l-.65,3.47Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.94,49.55h2.48c1.42,0,2.1.65,2.1,2,0,1.1-.34,1.69-1,1.82.76.11,1.23.78,1.23,1.89,0,1.76-.72,2.55-2.27,2.55H50.94Zm2,3.36c.78,0,1-.29,1-1.18s-.26-1.06-1.07-1.06h-.47v2.23Zm.12,3.74c.79,0,1.08-.34,1.08-1.31S53.83,54,52.9,54h-.46v2.63Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.91,49.55h1.54v6.87h2.78v1.41H56.91Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.33,49.55h4.25v1.38H63.86v1.92h2.53v1.31H63.86v2.28h2.78v1.4H62.33Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.69,9V31.41H26.31V9H58.69m1.85-1.85H24.45V33.27H60.55V7.13Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "31.3 26.68 36.38 21.63 40.4 24.15 46.94 17.25 54.77 26.68 31.3 26.68"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 38.57,
    cy: 17.22,
    r: 1.77
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/NoImage.40d80efb.svg";
export { ForwardRef as ReactComponent };